<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

//import Vue from 'vue'
//import { advMixin } from './scripts/advMixin'
//Vue.mixin(advMixin);

export default {
  name: 'App'
}
</script>


<style>
    @import 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css';
    @import './assets/css/side_bar.css';

    :root {
        /*--main-bg-color: red;*/
        /*--main-bg-color: #f0f0f0;*/
        --main-bg-color: #E6E6E6;
        --main-bg-color-new: white;
        --ligth-gray: #eeeeee;
        /*--bg-header-color: #ffffff;*/
        --bg-info-rect: #e6e6e6;
        --bg-header-color: #ffffff;
        --font-dark-gray: #808080;
        --font-dark-gray2: #606062;
        --font-shadow-gray: #B0B0B0;
        --gray-phone: #bebfc1;
        --blue-font-back: #cfe7f377;
        --gray-menu: #808080;
        --bg-round-rect1: #a22dc9;
        --bg-round-rect2: #a22dc9;
        --bg-pink: #a9518b;
        --bg-purple: #a22dc9;
        --blue-font-degrad1: #a6c1dc;
        --bg-blue-loading: #7ab9ea;
        --bg-blue-grad2: #07afd5;
        --blue-back-chegar2: #028fd5;
        --blue-back-chegar: #007fc5;
        --blue-font-tel: #2a6eb4;
        --blue-pilares-degrad1: #0f63acF6;
        --blue-text: #0c63af;
        --bg-blue-grad1: #0f63ac;
        --bg-blue-circle: #0f62ac;
        --bg-blue: #0f62ac;
        --bg-blue-grad1-t: #0f63acCC;
        --star-bg-color: #355587;
        --blue-pilares-degrad2: #3c4799;
        --blue-font-degrad2: #3279b700;


        --top-bar-heigth: 8vh;
        --top-bar-heigth_desk: 14vh;
        /*--menu-icon-top: 2.8vh;*/
        --menu-icon-top: 2.5vh;
        --menu-icon-top_desk: 5.3vh;

        --menu-icon-gray: #B0B0B0;

        /*--menu-icon-height: 0.26rem;*/
        --menu-icon-height: 0.3vh;
        --menu-icon-height: 0.28vh;

        /*--menu-icon-width: 3rem;*/
        /*--menu-icon-width: 4vh;*/
        --menu-icon-width: 3.5vh;

        /*--min-pag-stab-width: 17vw;*/
        --min-pag-stab-width: 25%;
        --min-pag-stab-height: 12vw;

        /*--menu-icon-width_small: 2.2rem;*/
        /*--menu-icon-width_small: 2.7vh;*/
        --menu-icon-width_small: 2.4vh;
        --menu-icon-spacing: 1rem;
        /*--menu-icon-spacing: 1.25vh;*/

        --popup-color: #FDFDFD;

        --font-size-title: 2.7vh;
        --font-size-title-mobile: 6vw;
        --font-size-title-mobile_2: 7vw;
        --font-size-title-mobile_small: 5vw;
        --cat-img-width: 4vh;
        --cat-img-height: 4vh;

        --estab-estab-height: 40vh;
        --estab-estab-height_2: 19.75vh;

        --action-size_1: 11vw;
        --action-size_2: 8vw;
        --action-margin_1: -5vw;
        --action-margin_2: -11vw;
        --foto-exp-max-weight: 85vh;

        --visao-4pilares-size: 18vw;

        --arrow-width: 8px;

        --empty-color: lightgrey;
    }

    /* Mobile */
    @media screen and (max-width: 990px) {
        :root {
            --menu-icon-top: 2.5vh;
            --menu-icon-width: 2.8vh;
            --menu-icon-width_small: 2vh;
            --menu-icon-spacing: 0.7rem;
        }
    }

    @media screen and (max-width: 1399px) {
        :root {
            --home-estab-height: 23vh;

            --home-estab-mos-height: 28vh;

            --home-panorama-height: 35vh;

            --minhaPagina-margin-top: 5vh;

            --estab-estab-height: 55vh;
            --estab-estab-height_2: 27.25vh;

            --action-size_1: 13vw;
            --action-size_2: 10vw;
            --action-margin_1: -3vw;
            --action-margin_2: -13vw;
        }
    }
    @media screen and (min-width: 1400px) {
        :root {
            --home-estab-height: 16vh;

            --home-estab-mos-height: 21vh;

            --home-panorama-height: 33vh;

            --minhaPagina-margin-top: 2vh;

            --action-size_1: 11vw;
            --action-size_2: 8vw;
            --action-margin_1: -3vw;
            --action-margin_2: -13vw;

            --visao-4pilares-size: 18vw;
        }
    }
    @media screen and (min-width: 1600px) {
        :root {
            --home-estab-height: 15vh;

            --home-estab-mos-height: 21vh;

            --home-panorama-height: 31vh;

            --minhaPagina-margin-top: 2vh;

            --action-size_1: 11vw;
            --action-size_2: 8vw;
            --action-margin_1: -3vw;
            --action-margin_2: -13vw;

            --visao-4pilares-size: 17vw;
        }
    }
    @media screen and (min-width: 1900px) {
        :root {
            --home-estab-height: 15vh;

            --home-estab-mos-height: 19vh;

            --home-panorama-height: 28vh;

            --minhaPagina-margin-top: 2vh;

            --font-size-title: 3.3vh;
            --cat-img-width: 4.5vh;
            --cat-img-height: 4.5vh;

            --action-size_1: 9.5vw;
            --action-size_2: 7vw;
            --action-margin_1: -3vw;
            --action-margin_2: -10vw;
            --foto-exp-max-weight: 95vh;

            --visao-4pilares-size: 16vw;
        }
    }
    @media screen and (min-width: 2200px) {
        :root {
            --home-estab-height: 15vh;

            --home-estab-mos-height: 19vh;

            --home-panorama-height: 26vh;

            --minhaPagina-margin-top: 2vh;

            --font-size-title: 3.3vh;
            --cat-img-width: 4.5vh;
            --cat-img-height: 4.5vh;

            --action-size_1: 9.5vw;
            --action-size_2: 7vw;
            --action-margin_1: -3vw;
            --action-margin_2: -10vw;

            --visao-4pilares-size: 11vw;
        }
    }

    @font-face {
        font-family: 'BigNoodleTitling'; /*a name to be used later*/
        src: url('/static/fonts/BigNoodleTitling.ttf'); /*URL to font*/
    }

    @font-face {
        font-family: 'Humanst521BT'; /*a name to be used later*/
        src: url('/static/fonts/Humanst521BT.ttf'); /*URL to font*/
    }

    @font-face {
        font-family: 'Humanst521LTBT'; /*a name to be used later*/
        src: url('/static/fonts/Humanst521LTBT.ttf'); /*URL to font*/
    }

    @font-face {
        font-family: 'BebasNeueBold'; /*a name to be used later*/
        src: url('/static/fonts/BebasNeueBold.otf'); /*URL to font*/
    }

    @font-face {
        font-family: 'Segoeui'; /*a name to be used later*/
        src: url('/static/fonts/seguisb_0.ttf'); /*URL to font*/
    }

    @font-face {
        font-family: 'Segoeui'; /*a name to be used later*/
        src: url('/static/fonts/segoeuib.ttf'); /*URL to font*/
        font-weight: bold;
    }




    #app {
      font-family: 'Humanst521LTBT', Helvetica, Arial,sans-serif;
      /*font-family: 'Humanst521BT', Courier, Helvetica, Arial,sans-serif;*/
       -webkit-font-smoothing: antialiased;
       -moz-osx-font-smoothing: grayscale;
      /*color: #2c3e50;*/
        color: #355587;
    }

    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        /*background-color: #E4E4E4;*/
        background-color: var(--main-bg-color);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue